module.exports = __webpack_public_path__ + "static/media/11NEPAD8.ba0cf445.jpg";